import React from 'react';
import EditableContent from '../EditableContent.tsx';

interface OrderingSectionProps {
  isEditMode: boolean;
  getContent: (key: string) => string;
  onContentSave: (contentId: string, value: string, contentType: 'text' | 'image') => Promise<void> | void;
  onDirtyStateChange: (contentId: string, isDirty: boolean) => void;
}

const ORDER_STEPS = [1, 2, 3, 4];
const INQUIRY_FIELDS = [1, 2, 3];

const OrderingSection: React.FC<OrderingSectionProps> = ({
  isEditMode,
  getContent,
  onContentSave,
  onDirtyStateChange,
}) => {
  const editable = (
    contentId: string,
    tag: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' | 'li' | 'dt' | 'dd' | 'small' | 'strong' | 'em',
    className?: string,
    multiline?: boolean
  ) => (
    <EditableContent
      contentId={contentId}
      contentType="text"
      tag={tag}
      className={className}
      multiline={multiline}
      defaultValue={getContent(contentId)}
      isEditing={isEditMode}
      onSave={onContentSave}
      onDirtyStateChange={onDirtyStateChange}
    />
  );

  return (
    <section id="ordering" className="ordering">
      <div className="section-head reveal">
        {editable('ordering-eyebrow', 'p', 'eyebrow')}
        {editable('ordering-tagline', 'span')}
      </div>
      <div className="order-title reveal">
        <h2>
          {editable('ordering-heading-line1', 'span')}
          <br />
          {editable('ordering-heading-line2', 'span')}
        </h2>
        {editable('ordering-intro', 'p', undefined, true)}
      </div>
      <div className="order-flow">
        {editable('order-flow-title', 'h3', 'order-block-title')}
        <ol className="order-steps">
          {ORDER_STEPS.map(n => (
            <li key={n}>
              <span className="order-step-index" aria-hidden="true">
                {String(n).padStart(2, '0')}
              </span>
              {editable(`order-step-${n}-title`, 'h4')}
              {editable(`order-step-${n}-description`, 'p')}
            </li>
          ))}
        </ol>
      </div>
      <div className="inquiry-panel">
        <div className="inquiry-panel-header">
          <div>
            {editable('inquiry-title', 'h3', 'order-block-title')}
            {editable('inquiry-subtitle', 'p')}
          </div>
          {isEditMode ? (
            editable('order-button-text', 'span')
          ) : (
            <a className="button dark" href="#contact">
              {getContent('order-button-text')} <span>↗</span>
            </a>
          )}
        </div>
        <dl className="inquiry-fields">
          {INQUIRY_FIELDS.map(n => (
            <div key={n}>
              {editable(`inquiry-field-${n}-title`, 'dt')}
              {editable(`inquiry-field-${n}-description`, 'dd', undefined, true)}
            </div>
          ))}
        </dl>
      </div>
      {editable('order-note', 'p', 'order-note')}
    </section>
  );
};

export default OrderingSection;
